import axiosInstance from '../common/axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;


const getBrand = async (id) => {
  const res = await axiosInstance.get(`${backendUrl}/api/brands/${id}`);
  return res.data;
};  

const saveBrand = async (data) => {
  const res = await axiosInstance.post(`${backendUrl}/api/brands`, data);
  return res.data;
};

export const updateBrand = async (id, data) => {

  const res = await axiosInstance.put(`${backendUrl}/api/brands/${id}`, data);
  return res.data;
};

 export const fetchBrand = async () => {
   
     const res = await axiosInstance.get(`${backendUrl}/api/brands`);
  return res.data;
  };



 export const deleteBrand = async (id) => {
   const res = await axiosInstance.delete(`${backendUrl}/api/brands/${id}`);
  return res.data;
  };

export default { getBrand, saveBrand, updateBrand , fetchBrand,deleteBrand };